import { ApiServiceBuilder } from "./apiServiceBuilder";

const currentAuthApiVersion = 1.0;
const authApiVersion = localStorage.getItem("authApiVersion") ?? currentAuthApiVersion;
const currentApiVersion = 3.5;
const apiVersion = localStorage.getItem("apiVersion") ?? currentApiVersion;

export const appApi = ApiServiceBuilder.create()
	.withBaseUrl(process.env.REACT_APP_API_BASE_URL ?? "")
	.withPrefix("/api")
	.withVersion(apiVersion)
	.withSuffix("/app")
	.withGetAndPostMethods()
	.build();

export const esusApi = ApiServiceBuilder.create()
	.withBaseUrl(process.env.REACT_APP_API_BASE_URL ?? "")
	.withPrefix("/api")
	.withVersion(apiVersion)
	.withSuffix("/esus")
	.withGetMethod()
	.build();

export const sintegradaApi = ApiServiceBuilder.create()
	.withBaseUrl(process.env.REACT_APP_API_BASE_URL ?? "")
	.withPrefix("/api")
	.withVersion(apiVersion)
	.withSuffix("/sintegrada")
	.withGetMethod()
	.build();

export const authApi = ApiServiceBuilder.create()
	.withBaseUrl(process.env.REACT_APP_AUTH_BASE_URL ?? "")
	.withVersion(authApiVersion)
	.asAuthApi()
	.withGetAndPostMethods()
	.build();

export const genericApi = ApiServiceBuilder.create().withAllMethods().build();

export const getSintegradaServerApi = () => {
	const sintegradaServerApi = localStorage.getItem("sintegradaServerApiUrl") ?? "";
	return ApiServiceBuilder.create().withBaseUrl(sintegradaServerApi).withGetMethod().build();
};
